import { EventEmitter } from 'events';
import IMessage from '../IMessage';
import validate from '../Validate/Validate';
import IProximity from './IProximity';

export interface IStateChangeMessage extends IMessage {
	detected: boolean;
}

export default class Proximity implements IProximity {
	public static MESSAGE_PREFIX: string = 'proximity';

	private eventEmitter: EventEmitter;
	private lastDetected: boolean = false;

	/** @internal */
	constructor(private messagePrefix: string) {
		this.eventEmitter = new EventEmitter();
	}

	/** @internal */
	public onStateChange(callback: (detected: boolean) => void): () => void {
		validate({ callback }).required().function();
		if (this.lastDetected) {
			callback(this.lastDetected);
		}
		this.eventEmitter.addListener('change', callback);
		return () => void this.eventEmitter.removeListener('change', callback);
	}

	/** @internal */
	public handleMessageData(data: IStateChangeMessage) {
		switch (data.type) {
			case this.getMessage('change'):
				if (data.detected !== this.lastDetected) {
					this.lastDetected = data.detected;
					this.eventEmitter.emit('change', data.detected);
				}
				break;
			default:
		}
	}

	private getMessage(name: string) {
		return this.messagePrefix + '.' + Proximity.MESSAGE_PREFIX + '.' + name;
	}
}
